const macrotask = (callback ) => {
    setTimeout(callback, 0);
};

export default macrotask;
